import {
  BaseFieldProps,
  getTextInputProps,
  InputField,
  InputItem,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { HelperText } from '@windmill/react-ui';
import ReactTooltip from 'react-tooltip';

import contextAlertIcon from '../assets/context-alert.svg';
import greenCircleCheck from '../assets/green-circle-check.svg';
import { EmailFieldProps, OrganizationCreate } from './types';

const getTooltipContent = (toolTipStr: string) => {
  return <div className="w-52">{toolTipStr}</div>;
};

export const EmailInput = ({
  email,
  showCompanyDomainAlert,
  isUserEmailBusinessDomain,
  errors,
  register,
  disabled,
}: EmailFieldProps) => {
  const isEmailValid =
    email?.length > 3 && !errors.email && !showCompanyDomainAlert;
  let emailFieldClassNames = undefined;
  if (isUserEmailBusinessDomain) {
    emailFieldClassNames =
      'text-success-icon border-none bg-none pointer-events-none cursor-not-allowed bg-gray-200 dark:bg-gray-800 border-slate-600';
  } else if (isEmailValid) {
    emailFieldClassNames = 'text-success-icon border-alert-success';
  }

  return (
    <div className="relative">
      <div className="relative">
        <InputField
          className={`${
            disabled ? 'cursor-not-allowed' : ''
          } ${emailFieldClassNames}`}
          disabled={disabled}
          errors={errors}
          inputKey="email"
          register={register}
          registerProps={{
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address',
            },
          }}
          title="Email"
        />
        {isEmailValid && (
          <div className="absolute top-10 right-2">
            <img
              alt="valid email green circle checkmark"
              src={greenCircleCheck}
            />
          </div>
        )}
      </div>
      {showCompanyDomainAlert && (
        <div className="absolute top-11 right-0 md:top-10 md:right-2">
          <img
            alt="email domain context warning"
            data-tip="We recommend that you use a custom domain email associated with your business to create an organization."
            src={contextAlertIcon}
          />
          <ReactTooltip
            effect="solid"
            getContent={getTooltipContent}
            multiline={true}
            place="right"
            resizeHide={true}
            scrollHide={true}
          />
        </div>
      )}
    </div>
  );
};

export const FirstLastNameInput = ({
  errors,
  register,
}: BaseFieldProps<OrganizationCreate>) => {
  const firstNameProps = getTextInputProps({
    inputKey: 'firstName',
    errors,
    register,
  });
  const lastNameProps = getTextInputProps({
    inputKey: 'lastName',
    errors,
    register,
  });

  return (
    <InputItem title="Legal First and Last Name">
      <div>
        <div className="flex flex-row">
          <input
            {...firstNameProps}
            className={`${firstNameProps.className} mr-1`}
          />
          <input
            {...lastNameProps}
            className={`${lastNameProps.className} ml-1`}
          />
        </div>
        {errors.firstName?.message && (
          <HelperText valid={false}>{errors.firstName?.message}</HelperText>
        )}
        {errors.lastName?.message && (
          <HelperText valid={false}>{errors.lastName?.message}</HelperText>
        )}
      </div>
    </InputItem>
  );
};
